import { useLayoutEffect, useRef } from 'react';
import type { CSSProperties } from 'react';
import { Text } from '@mantine/core';

type LoadingScreenProps = {
  exiting: boolean;
  exitDurationMs: number;
  onVisibilityOpportunity: (timestamp: number) => void;
};

export function LoadingScreen({
  exiting,
  exitDurationMs,
  onVisibilityOpportunity,
}: LoadingScreenProps) {
  const callbackSentRef = useRef(false);

  useLayoutEffect(() => {
    const frame = window.requestAnimationFrame((timestamp) => {
      if (!callbackSentRef.current) {
        callbackSentRef.current = true;
        onVisibilityOpportunity(timestamp);
      }
    });
    return () => window.cancelAnimationFrame(frame);
  }, [onVisibilityOpportunity]);

  return (
    <main
      className={`app-loading-screen${exiting ? ' app-loading-screen--exiting' : ''}`}
      aria-hidden="true"
      style={{ '--startup-exit-duration': `${exitDurationMs}ms` } as CSSProperties}
    >
      <section className="app-loading-screen__content">
        <div className="app-loading-screen__brand-mark" aria-hidden="true">
          <img src="/brand-logo-transparent.png" alt="" />
        </div>
        <div className="app-loading-screen__copy">
          <Text className="app-loading-screen__wordmark" aria-hidden="true">LocsClub</Text>
        </div>
      </section>
    </main>
  );
}
